import { CloseOutlined } from '@ant-design/icons';
import { createOverlayManager } from './OverlayManager';
import { Box, Breadcrumbs, IconButton, Stack, SwipeableDrawer, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

const DrawerRenderer = ({ Component, props, options, isOpen, onClose }) => {
  const { title, ...restOptions } = options;
  const drawerTitle = typeof title === 'function' ? title(props) : title;

  return (
    <SwipeableDrawer anchor="right" onClose={onClose} open={isOpen} {...restOptions}>
      <Box p={3}>
        <Stack direction={'row'} justifyContent="space-between" alignItems={'center'} mb={2}>
          {drawerTitle && <Box sx={{ fontSize: '18px', fontWeight: 500 }}>{drawerTitle}</Box>}
          <IconButton
            onClick={onClose}
            sx={{
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseOutlined />
          </IconButton>
        </Stack>
        <Component {...props} />
      </Box>
    </SwipeableDrawer>
  );
};

const { Provider: BaseDrawerProvider, useOverlay: useDrawerBase } = createOverlayManager(DrawerRenderer);

export const DrawerProvider = ({ children }) => <BaseDrawerProvider>{children}</BaseDrawerProvider>;

export const useDrawer = () => {
  const { open, close } = useDrawerBase();

  return {
    openDrawer: (Component, props = {}, options = {}) => open(Component, props, options),
    closeDrawer: close,
  };
};
